import VConsole from 'vconsole'
let vconsole = new VConsole()
export default vconsole
